import { Paper, Tab, Tabs } from "@mui/material"
import { useNavigate } from "react-router-dom"

type Props = {
  activeTab: 0 | 1
}

export function ReportTabs({ activeTab }: Props) {
  const navigate = useNavigate()

  return (
    <Paper sx={{ display: "flex", flexDirection: "column" }}>
      <Tabs value={activeTab} onChange={(_, v) => v !== activeTab && navigate(v === 0 ? "/report" : "/report/growth")}>
        <Tab label="Usage" />
        <Tab label="Growth" />
      </Tabs>
    </Paper>
  )
}
